module.exports = __webpack_public_path__ + "static/projects-d0368d3de96a2925cc9242c7bb974c50.jpeg";